
<template>
  <!-- 展示全部的数据 -->
  <div>
    <div>
      <span>业务员</span>
      <Select
        v-model="selectUserId"
        style="width:100px"
        :label-in-value="true"
        @on-change="changeUser"
      >
        <Option v-for="user in userAlls" :key="user.label" :value="user.value">{{ user.label }}</Option>
      </Select>

      <!-- 日期: -->
      <DatePicker
        type="daterange"
        @on-change="dateChange"
        placement="bottom-end"
        placeholder="选择日期"
        style="width: 100px"
      ></DatePicker>
      <Button type="primary" v-on:click="getPlanDatas()">确定</Button>
    </div>
    <div class="map-control">
      <div id="mapContainer">map</div>
    </div>
  </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";

import "../assets/stylesheets/map_demo.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/jquery.min.js";
import "../assets/javascript/calendal_demo.js";

import getColor from "../service/randomColor.js";
import {
  initMap,
  openMarWindow,
  openLineWindow
} from "../assets/javascript/map.js";
export default {
  data: function() {
    return {
      selectUserId: "",
      userAlls: [],
      startDate: "",
      endDate: "",
      layerGroup: new L.layerGroup([]),
      levelKey: "level",
      levelCount: {},
      isLoading: false,
      loadingText: "加载中...",
      userId: "",
      nickName: "",
      today: "",
      dayCust: 0,
      currentUser: {},
      users: [],
      custCount: 0, //全部的客户数
      visitDistance: 0,
      visitDurction: 0,
      visitDays: 0,
      restDays: 0,
      futureVisit: [],
      pointsMap: new Map(), //全部的客户
      featureGroup: null, //用来存储现在显示的
      lineMap: new Map(), //保存每一天的线路信息
      changeMonth: true,
      showTable: false,
      showCalendar: true,
      showCalendarName: "隐藏日历",
      shoTabName: "展示列表",
      month: "2019-01",
      focusLayers: [], // 焦点图层
      focusLineLayer: null,
      focusMarker: null, // 焦点点位
      mashiObjectMap: {
        id: "编号",
        lat: "lat",
        lng: "lng",
        oneChannel: "一级渠道",
        twoChannel: "二级渠道",
        threeChannel: "三级渠道",
        businessName: "业务名称",
        businessNum: "业务工号",
        supplierName: "供货商名称",
        city: "城市",
        cityGroups: "城市群",
        bigRegion: "大区",
        province: "省份",
        bindTime: "绑定时间",
        address: "联系地址",
        shopName: "门店名称",
        shopNum: "门店编码",
        frm: "RFM频率",
        frequency: "RFM频率",
        staytime: "三级渠道"
      }
    };
  },
  mounted() {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      this.$router.push({ path: "/demo-login" });
    }
    this.nickName = sessionStorage.getItem("nickname");
    this.userId = userId;
    //初始化地图
    this.map = initMap();
    this.map.on("popupclose", this.clearFocus);
    this.getUsers();
  },
  methods: {
    getUsers: async function() {
      //获取用户列表
      const res = await getData.get(api.planDemoRegions, {
        userId: this.userId
      });
      if (res.data && res.data.status) {
        for (let i = 0; i < res.data.regions.length; i += 1) {
          const userInfo = res.data.regions[i];
          this.userAlls.push({
            value: userInfo.userId,
            label: userInfo.nickName
          });
          if (i === 0) {
            this.selectUserId = userInfo.userId;
          }
        }
      }
    },
    changeUser: function(obj) {
      this.selectUserId = obj.value;
    },
    //日期更改触发
    dateChange: async function(date) {
      if (date[0] === "") return; //清空日期
      this.startDate = date[0];
      this.endDate = date[1];
    },
    getPlanDatas: async function() {

      const res = await getData.get(api.planDemoData, {
        userId: this.selectUserId,
        startDay: this.startDate,
        endDay: this.endDate
      });
      if (res.data && res.data.status) {
        const pointsAll = res.data.info.points_all;
        for (let pointInfo of pointsAll) {
          this.pointsMap.set(pointInfo.id, pointInfo);
          const getKey = pointInfo.attrs[this.levelKey];
          if (!getKey) continue;
          if (this.levelCount.hasOwnProperty(getKey)) {
            this.levelCount[getKey] += 1;
          } else {
            this.levelCount[getKey] = 1;
          }
        }
        this.custCount = pointsAll.length;

        this.restDays = 0;
        this.lineMap = new Map();
        this.layerMap = new Map();
        this.visitDays = 0;
        let distance = 0;
        let durction = 0;
        for (let line of res.data.info.line_info) {
          if (!line.isHoliday) {
            distance += line.planData.route.distance;
            durction += line.planData.route.duration;
            this.visitDays += 1;
          } else {
            this.restDays += 1;
          }
          this.lineMap.set(line.date, line.planData);
        }
        this.visitDistance = `${(distance / 1000).toFixed(2)} km`;
        this.visitDurction = `${(durction / 60).toFixed(2)} h`;

        this.drawAllData();
      }
    },
    drawAllData() {
      //步行:1 公交:2 驾车:3  公交+步行:21  公交+驾车+步行:231
      //画全部的信息
      const layers = [];

      for (let [key, value] of this.lineMap) {
        if (!value) continue;
        const color = getColor.getColor();

        for (let i = 0; i < value.reachTimes.length; i++) {
          const reachTimeInfo = value.reachTimes[i];
          const pointId = reachTimeInfo.orderId;
          const point = this.pointsMap.get(pointId);

          const divHtml = `<div class='way-points' style='background-color:${color}'>${i +
            1}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          let stayTime = point.attrs.staytime;
          let times = point.attrs.frequency;
          const dateString = point.attrs.dates.join(";");
          let reg = new RegExp(";", "g");
          let marPups = [];
          const self = this;
          if (this.nickName === "玛氏") {
            for (const key in point.attrs) {
              //循环遍历key
              if (key === "dates") continue;
              if (!self.mashiObjectMap.hasOwnProperty(key)) continue;
              marPups.push({
                name: self.mashiObjectMap[key],
                cont: point.attrs[key]
              });
            }
          } else {
            marPups = [
              {
                name: "名称",
                cont: point.attrs.name
              },
              {
                name: "访问频率",
                cont: `${times}次/月`
              }
            ];
          }
          marPups = marPups.concat([
            {
              name: "预计到达",
              cont: reachTimeInfo.time
            },
            {
              name: "预计离开",
              cont: reachTimeInfo.leaveTime
            },
            {
              name: "停留时长",
              cont: `${stayTime}分钟`
            },
            {
              name: "拜访日期",
              cont: dateString.replace(reg, "<br/>")
            }
          ]);

          layers.push(
            L.marker([point.point.coordinates[1], point.point.coordinates[0]], {
              icon: wayDivIcon
            }).on("click", e => {
              openMarWindow(e, marPups);
              this.setFocusMarker(e);
            })
          );
          //***************画线***************/
          const route = value.route.path[i];
          if (route) {
            let vehicles = [];
            for (let vehstr of route.vehicle_types) {
              if (vehstr.type === 1) {
                vehicles.push({
                  name: "步行",
                  cont: `${vehstr.distance}米`
                });
              } else if (vehstr.type === 2) {
                vehicles.push({
                  name: "公交",
                  cont: vehstr.busName.replace(/\(.*?\)/g, "")
                });
              } else if (vehstr.type === 3) {
                vehicles.push({
                  name: "驾车",
                  cont: `${(vehstr.distance / 1000).toFixed(2)}公里`
                });
              }
            }
            const attrRoutes = [];
            attrRoutes.push({
              name: "分段名称",
              cont: `${i}-${i + 1}`
            });
            attrRoutes.push({
              name: "拜访日期",
              cont: key
            });
            attrRoutes.push({
              name: "分段里程",
              cont: `${route.distance}m`
            });
            attrRoutes.push({
              name: "花费时长",
              cont: route.duration
                ? `${route.duration.toFixed(2)}min`
                : `${0}min`
            });
            attrRoutes.push({
              name: "通勤方式",
              vehicles
            });
            const latLngs = [];
            const routes = route.path.split(";");
            for (let route of routes) {
              latLngs.push(route.split(",").reverse());
            }
            layers.push(
              L.polyline(latLngs, {
                color: color
              }).on("click", e => {
                openLineWindow(e, attrRoutes);
                this.setFocusLineLayer(layers, latLngs);
              })
            );
          }
        }
      }
      this.clearLayer();
      this.featureGroup = L.featureGroup(layers);
      this.showAllFeature();
    },
    showAllFeature: async function(date) {
      this.featureGroup.addTo(this.map);
      this.map.fitBounds(this.featureGroup.getBounds());
    },
    clearLayer() {
      if (this.featureGroup !== null) {
        this.featureGroup.remove();
        this.featureGroup = null;
      }
    },
    /**
     * 焦点路线
     */ setFocusLineLayer(layers, latLngs) {
      this.clearFocusLineLayer();
      for (let layer of layers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(999);
        }
      }
      if (!this.focusLineLayer) {
        this.focusLineLayer = L.polyline(latLngs, {
          color: "#ff0000",
          weight: 5
        });
      } else {
        this.focusLineLayer.setLatLngs(latLngs);
      }
      this.focusLineLayer.addTo(this.map).bringToFront();
      this.focusLayers = layers;
    },
    clearFocusLineLayer() {
      for (let layer of this.focusLayers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(0);
        }
      }
      this.focusLayers = [];
      if (this.focusLineLayer) {
        this.focusLineLayer.remove();
      }
    },
    /**
     * 点位焦点
     */
    setFocusMarker(e) {
      this.focusMarker = e.target;
      let dom = this.focusMarker.getElement();
      let className = dom.className;
      if (className.indexOf("focus-marker-point") === -1) {
        className += " focus-marker-point";
      }
      dom.className = className;
    },
    clearFocusMarker() {
      if (this.focusMarker) {
        let dom = this.focusMarker.getElement();
        if (dom !== null) {
          let className = dom.className;
          if (className.indexOf("focus-marker-point") > -1) {
            className = className.replace(" focus-marker-point", "");
          }
          dom.className = className;
        }
      }
      this.focusMarker = null;
    },
    clearFocus() {
      this.clearFocusLineLayer();
      this.clearFocusMarker();
    }
  }
};
</script>
<style lang="less">
.map-control {
  width: 100%;
  height: calc(~"100% - 32px");
}
#mapContainer {
  height: 100%;
  width: 100%;
}
.focus-marker-point .way-points {
  background-color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DemoShowAll.vue